module.exports = __webpack_public_path__ + "img/collection-weddingRingsRosegold.e6e7f76.webp";